<script setup lang="ts">
import {useTemplateRef} from "vue";
import {AudioRecorder} from "@/Components/Global";

const model = defineModel();
const audioRecorder = useTemplateRef("audioRecorder");

defineExpose({
    stopRecording: () => audioRecorder.value?.stopRecording(),
    saveRecording: () => audioRecorder.value?.saveRecording(),
    deleteRecording: () => audioRecorder.value?.deleteRecording(),
});
</script>
<template>
    <div>
        <h3 class="mt-1 px-1 text-sm font-bold">Record your response</h3>
        <p class="mb-3 px-1 text-xs">
            Long press to start recording. Tap again to pause. When you have finished recording press the stop button.
        </p>
        <AudioRecorder ref="audioRecorder" v-model="model" />
    </div>
</template>
<style scoped></style>
